import React from "react";

import PageComponents from "../../components/CommonComponents/CommonPageComponents";

const PageNotFound: React.FC = () => {
  return (
  <PageComponents
      titleText="Page Not Found"
      msgText="Sorry, the page you are looking for doesn't exist."
      buttonText="Go Home"
      buttonLink="/"
    />
  );
};

export default PageNotFound;
